export default "__VITE_ASSET__ClNHvzgT__"